import axios from "axios";
import {
  BASE_URL,
  GET_TMC_CONNECT_NUMBER_ENDPOINT,
  UPDATE_TMC_CONNECT_NUMBER_ENDPOINT,
} from "constants/api-config-constants";
import {
  CallCentreDetails,
  GetCallCentreResponse,
  UpdateCallCentreResponse,
} from "interfaces/call-centre.interface";

export const getCallCentreNumber = async (
  brand: string = "toyota"
): Promise<GetCallCentreResponse> => {
  const url = `${BASE_URL}${GET_TMC_CONNECT_NUMBER_ENDPOINT}?brand=${brand.toLowerCase()}`;
  return axios.get(url);
};

export const updateCallCentreNumber = async (
  payload: CallCentreDetails
): Promise<UpdateCallCentreResponse> => {
  const url = `${BASE_URL}${UPDATE_TMC_CONNECT_NUMBER_ENDPOINT}`;
  return axios.put(url, payload);
};
